<template>
  <header>
    <div class="container">
      <div class="brand">
        <img src="../assets/jf-lorenzo-llorente-arquitecto-logo.png" alt="JF Lorenzo Arquitecto" />
      </div>
    </div>
  </header>
</template>

<script>
export default {

  name: 'Cabecera',

  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
.brand {
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
